import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from "shared/components/checkbox";
import CustomDataHelp from "./CustomDataHelp";

export default class CustomDataCheckbox extends React.Component {
  static propTypes = {
    moveCustomData:   PropTypes.bool,
    toggleCustomData: PropTypes.func
  };

  toggleEnabled() {
    const { toggleCustomData, moveCustomData } = this.props;
    toggleCustomData({ moveCustomData: !moveCustomData });
  }

  render() {
    return (
      <Checkbox
        id={"custom-data-check"}
        state={this.props.moveCustomData}
        disabled={false}
        label={<CustomDataHelp />}
        onChange={this.toggleEnabled.bind(this)}
      />
    );
  }
}
